/** Coarse relative time: "just now", then "5m ago", "3h ago", "2d ago". */
export function timeAgo(
  ms: number,
  { now = Date.now(), suffix = "ago" }: { now?: number; suffix?: string } = {},
) {
  const diff = now - ms;
  if (diff < 60000) return "just now";
  if (diff < 3600000) return `${Math.floor(diff / 60000)}m ${suffix}`;
  if (diff < 86400000) return `${Math.floor(diff / 3600000)}h ${suffix}`;
  return `${Math.floor(diff / 86400000)}d ${suffix}`;
}
